import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ProviderSearchViewModel } from "src/erp/arap/rawData/providerSelector-viewModel";
import { ProductSelector } from "src/erp/inventory/rawData/product/productSelector";
import { WarehouseSelector } from "src/erp/inventory/rawData/warehouse/warehouseSelector";
import { FileSelectorViewModel } from "uicomponents";
import { CreateInvoiceViewModel, LineItem } from "./createInvoice-viewModel";

export class CreateInvoiceView extends View<CreateInvoiceViewModel>{
    GetViewUniqueId(): string {
        return "V-B137B0B3-CA6F-4E89-8139-5A6756804C73"
    }
    loadHtml(): string {
        let element = require('./createInvoice.html').default;
        let style = require('./createInvoice.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set totalPrice(v: number) { this._totalPrice = v; } public get totalPrice(): number { return this._totalPrice;} private _totalPrice: number;
    public set productSearch(v: ProductSelector) { this._productSearch = v; } public get productSearch(): ProductSelector { return this._productSearch;} private _productSearch: ProductSelector;
    public set elementCount(v: number) { this._elementCount = v; } public get elementCount(): number { return this._elementCount;} private _elementCount: number;
    public set additions(v: number) { this._additions = v; } public get additions(): number { return this._additions;} private _additions: number;
    public set deficits(v: number) { this._deficits = v; } public get deficits(): number { return this._deficits;} private _deficits: number;
    public set finalPrice(v: number) { this._finalPrice = v; } public get finalPrice(): number { return this._finalPrice;} private _finalPrice: number;
    public set transportPrice(v: number) { this._transportPrice = v; } public get transportPrice(): number { return this._transportPrice;} private _transportPrice: number;
    public set transportAddress(v: string) { this._transportAddress = v; } public get transportAddress(): string { return this._transportAddress;} private _transportAddress: string;
    public set providerSearcher(v: ProviderSearchViewModel) { this._providerSearcher = v; } public get providerSearcher(): ProviderSearchViewModel { return this._providerSearcher;} private _providerSearcher: ProviderSearchViewModel;
    public set lineItems(v: ObservableArray<LineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<LineItem> { return this._lineItems;} private _lineItems: ObservableArray<LineItem>;
    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName;} private _customerName: string;
    public set customerCode(v: string) { this._customerCode = v; } public get customerCode(): string { return this._customerCode;} private _customerCode: string;
    public set warehouseSelector(v: WarehouseSelector) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseSelector { return this._warehouseSelector;} private _warehouseSelector: WarehouseSelector;
    public set selectedWarehouseName(v: string) { this._selectedWarehouseName = v; } public get selectedWarehouseName(): string { return this._selectedWarehouseName;} private _selectedWarehouseName: string;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

    requestCreateFactor(){
        this.dataContext.requestCreatePurchaseFactor();
    }

    import() {
        this.dataContext.import();
    }
    
    export() {
        this.dataContext.export();
    }

}
